import React, { Fragment, } from 'react';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Button, Box, Typography } from '@material-ui/core';
import { marginBottom } from "../../../config/styles";
import { invokePostService, invokeGetService, setInnerScreenRender } from "../../../store/global/actions";
import { flattenArray, getMessageWithChildren } from '../../../services/builder/util';


export default function DeleteEventType(props) {
    const { eventTypeId, onClose, onCompletion } = props;
    const dispatch = useDispatch();

    const [eventTypeUsedCount, setEventTypeUsedCount] = useState([]);
    const [fieldsWithMessageAsType, setFieldsWithMessageAsType] = useState(0);
    const [msg, setMsg] = useState('')
    const [isLoading, setLoading] = useState(false);

    const findParentMessage = ({field, messageAndChildren}) => {
        try {
            const message =  messageAndChildren.find(message => {
                const messageFields = flattenArray(message?.children )
                const fieldIds = messageFields?.map(item => item?._id)
                if(fieldIds?.includes(field?._id)){
                    return message;
                }
            })

            return message;
            
        } catch (error) {
            console.error(error);
            return null
        }
        
    }

    const findFieldWithMessageType = ({message, fields, messageAndChildren}) => {
        try {

            let filteredFields = fields?.filter(field => field?.attributes?.type === message) || [];
            filteredFields = filteredFields?.map(field => {
                const parentMsg = findParentMessage({field, messageAndChildren})
                field.message = parentMsg ?  parentMsg?.name : "";
                return field;
            })
            setFieldsWithMessageAsType(filteredFields?.length);
            return filteredFields;
        } catch (error) {
            console.error("Finding fields with message as field failed.", error);
            return null;
        }
    };


    const getAlertMessageForMessageAsType = ({fields, selectedMsg}) => {
        try {
            let message = ''
            
            const fieldsNames = fields?.map(item =>  `${item?.name}(${item?.message})` );
            message = `Cannot delete the event type ${selectedMsg?.name}. Event type is used as type in ${fieldsNames?.length > 1 ? 'fields' : 'field'} '${fieldsNames?.join(", ")}'`;
            return message;
            
        } catch (error) {
            console.error(error);
            return "Cannot delete the event type."
        }
    }



    useEffect(() => {
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then((response) => {
                if (response.status) {
                    let allEvents = response.data.events;
                    let allMessages = response.data.messages;


                    let selectedMsg = allMessages.find(item => item._id == eventTypeId);
                    let count = allEvents.filter(item => item.message == eventTypeId)?.length;
                    setEventTypeUsedCount(count)

                    const messageAndChildren = getMessageWithChildren({fields: response.data.fields, messages: allMessages})

                    const fieldsWithTypeMessage = findFieldWithMessageType({message: eventTypeId, fields: response?.data?.fields, messageAndChildren })

                    let message = `Are you sure you want to delete Event Type ${selectedMsg?.name} ?`
                    if (count > 0){
                        message = `Cannot delete the event type ${selectedMsg?.name}. Event type is used in existing transactions!`
                    }else{
                        if(fieldsWithTypeMessage && fieldsWithTypeMessage?.length > 0){
                            message = getAlertMessageForMessageAsType({ selectedMsg, fields: fieldsWithTypeMessage})
                        }
                    } 
                    setMsg(message)
                }

            })
    }, [])

    const onDelete = () => {
        setLoading(true)
        dispatch(invokePostService('deleteMessage', {}, [eventTypeId]))
            .then((response) => {
                if (response?.status) {
                    dispatch(setInnerScreenRender())
                    onCompletion('Event type', 'delete')
                }

                setLoading(false)

            })

    }

    return (
        <>
            <Box className={"deleteDialogBox"}>

                <Grid xs={12} style={marginBottom}>
                    <Fragment>
                        <Typography > {msg} </Typography>
                    </Fragment>
                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <Button onClick={onClose} color="primary" variant="outlined" style={{ marginLeft: 10 }} >
                        Cancel
                    </Button>
                    <Button onClick={onDelete} disabled={fieldsWithMessageAsType > 0 || eventTypeUsedCount > 0 || isLoading} color="secondary" variant="contained" style={{ marginLeft: 10 }}>
                        {isLoading ? 'Deleting..' : 'Delete'}
                    </Button>
                </Grid>

            </Box>
        </>
    )
}
